import { gql } from "@apollo/client/core";

/**
 * This file is generated from the metadata.json file. 
 * ** DO NOT edit this file manually **
 *
 * @example
 * ```
 * this.apollo.mutate({
 *     mutation: INVOICE_REVERSIBLE,
 *     variables: {
 *         idWrapper: idWrapper
 *     }
 * });
 * ```
 */
export const INVOICE_REVERSIBLE = gql`
mutation INVOICE_REVERSIBLE ($idWrapper: ReqIdWrapper2!) {
    InvoiceReversible(idWrapper: $idWrapper) {
        conflicts {
            draftInvoiceId
            jobId
            jobName
        }
        reversible
    }
}`;
/**
 * This file is generated from the metadata.json file. 
 * ** DO NOT edit this file manually **
 *
 * @example
 * ```
 * this.apollo.mutate({
 *     mutation: REVERSE_INVOICE,
 *     variables: {
 *         reverseInvoiceRequest: reverseInvoiceRequest
 *     }
 * });
 * ```
 */
export const REVERSE_INVOICE = gql`
mutation REVERSE_INVOICE ($reverseInvoiceRequest: ReverseInvoiceRequest!) {
    ReverseInvoice(reverseInvoiceRequest: $reverseInvoiceRequest) {
        draftInvoiceId
        invoiceId
    }
}`;
